import React from 'react';
import PropTypes from 'prop-types';

import Utility from '../../../util/utilityfunctions';

import ReactSelect from '@ey/canvascoreservices/ReactSelect';

const SelectDropdown = (props) => {
	const {
		hideSelectedOptions,
		searchInLabelOrValue,
		airaLabelValue,
		blurInputOnSelect,
		className,
		closeMenuOnScroll,
		closeMenuOnSelect,
		defaultMenuIsOpen,
		defaultValue,
		formatGroupLabel,
		formatOptionLabel,
		formLabel,
		groupHeading,
		id,
		isClearable,
		isDisabled,
		isMulti,
		isSearchable,
		menuIsOpen,
		name,
		onLabelClickSetFocus,
		onInputKeyDown,
		openMenuOnFocus,
		options,
		placeholder,
		errorMessage,
		showErrorMessage,
		onChange,
		onFocus,
		onBlur,
		value,
		noOptionsMessage,
		footer,
		menuPlacement,
		components,
		clearAllValuesLabel,
		onBlurHideMenu,
		customClearIcon,
		maxOptionsBeforeScroll,
		theme = Utility.getMotifTheme()
	} = props;
	return (
		<ReactSelect
			hideSelectedOptions={hideSelectedOptions}
			searchInLabelOrValue={searchInLabelOrValue}
			airaLabelValue={airaLabelValue}
			blurInputOnSelect={blurInputOnSelect}
			className={`select-dropdown ${className}`}
			closeMenuOnScroll={closeMenuOnScroll}
			closeMenuOnSelect={closeMenuOnSelect}
			defaultMenuIsOpen={defaultMenuIsOpen}
			defaultValue={defaultValue}
			formatGroupLabel={formatGroupLabel}
			formatOptionLabel={formatOptionLabel}
			groupHeading={groupHeading}
			id={id}
			isClearable={isClearable}
			isDisabled={isDisabled}
			isMulti={isMulti}
			isSearchable={isSearchable}
			menuIsOpen={menuIsOpen}
			name={name}
			openMenuOnFocus={openMenuOnFocus}
			options={options}
			placeholder={placeholder}
			errorMessage={errorMessage}
			onInputKeyDown={onInputKeyDown}
			onLabelClickSetFocus={onLabelClickSetFocus}
			showErrorMessage={showErrorMessage}
			formLabel={formLabel}
			onChange={onChange}
			onFocus={onFocus}
			value={value}
			theme={theme}
			noOptionsMessage={noOptionsMessage}
			footer={footer}
			menuPlacement={menuPlacement}
			components={components}
			clearAllValuesLabel={clearAllValuesLabel}
			customClearIcon={customClearIcon}
			onBlurHideMenu={onBlurHideMenu}
			onBlur={onBlur}
			maxOptionsBeforeScroll={maxOptionsBeforeScroll}
		/>
	);
};

SelectDropdown.propTypes = {
	formatOptionLabel: PropTypes.func
};

SelectDropdown.defaultProps = {
	formatOptionLabel: (option) => <span title={option.label}>{option.label}</span>
};

export default SelectDropdown;
